/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Injectable} from '@angular/core';
import {SortDirection} from '../../api/generic/contracts/sort-direction.enum';
import {ClaimListFilterColumnEnum} from '../claim-main-page/claim-list/claim-list-filter-column.enum';
import {ClaimQueryModel} from '../../api/ms-claims/contracts/claim-query.model';
import {AbstractSearchCriteriaService} from '../../shared/filter/abstract-search-criteria.service';

@Injectable({
    providedIn: 'root'
})
export class ClaimSearchCriteriaService extends AbstractSearchCriteriaService<ClaimListFilterColumnEnum> {

    /**
     * Clear all the criteria
     */
    clear(): void {
        // clear stored filters
        this.stateMap.clear();
        // Sort criteria
        this.sortDirection = SortDirection.DESC;
        this.sortedBy = ClaimListFilterColumnEnum.LAST_CHANGE_DATETIME;
        // Pagination
        this.pageSize = 20;
        this.pageNumber = 1;
        this.totalResults = 0;
    }

    public getClaimQuery(hasPaginationCriteria?: boolean): ClaimQueryModel {
        const partnerCodes = this.mapCodeCriterion(ClaimListFilterColumnEnum.PARTNER);
        const supplyingPackingPlantCodes = this.mapCodeCriterion(ClaimListFilterColumnEnum.SUPPLYING_PACKING_PLANT);
        const number = this.mapStringCriterion(ClaimListFilterColumnEnum.NUMBER);
        const material = this.mapStringCriterion(ClaimListFilterColumnEnum.MATERIAL);
        const statusCodes = this.mapCodeCriterion(ClaimListFilterColumnEnum.STATUS);
        const sentDate = this.mapDateCriterion(ClaimListFilterColumnEnum.SENT_DATE);
        const changedOn = this.mapDateCriterion(ClaimListFilterColumnEnum.LAST_CHANGE_DATETIME);
        const claimCodes = this.mapCodeCriterion(ClaimListFilterColumnEnum.CLAIM_CODE);
        const lotNumber = this.mapNullableStringCriterion(ClaimListFilterColumnEnum.LOT_NUMBER);
        const referenceNumber = this.mapNullableStringCriterion(ClaimListFilterColumnEnum.REFERENCE_NUMBER);
        const modelType = this.mapNullableStringCriterion(ClaimListFilterColumnEnum.MODEL_TYPE);
        const modelCode = this.mapNullableStringCriterion(ClaimListFilterColumnEnum.MODEL_CODE);

        return {
            searchCriteria: {
                partnerCodes,
                supplyingPackingPlantCodes,
                number,
                material,
                statusCodes,
                sentDate,
                changedOn,
                claimCodes,
                lotNumber,
                referenceNumber,
                modelType,
                modelCode
            },
            paginationCriteria: hasPaginationCriteria ? this.paginationCriteria : this.resetPaginationCriteria
        };
    }
}
